/* tslint:disable */
/* eslint-disable */
/**
 * B2B IVR
 * Implements B2B IVR endpoints
 *
 * The version of the OpenAPI document: v0p11
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * Information about an IVR conversation being transferred to a chat

 * `conversationId` - Identifier for the IVR conversation to be transferred to chat
 * `source` - Source for the IVR conversation
 * @export
 * @interface ChatTransfer
 */
export interface ChatTransfer {
    /**
     * Identifier for the IVR conversation to be transferred to chat
     * @type {string}
     * @memberof ChatTransfer
     */
    'conversationId': string;
    /**
     * Source for the IVR conversation
     * @type {string}
     * @memberof ChatTransfer
     */
    'source': string;
}
/**
 * Request to encode a booking id

 * `chatTransfer` - The Chat Transfer object if needed
 * `requestType` - Type of user request similar to what's provided in chat
 * `locale` - User locale, used to direct requests to the appropriate agents
 * `funnelType` - Kustomer funnel type for routing requests. String should be snake case
 * @export
 * @interface EncodeBookingRequest
 */
export interface EncodeBookingRequest {
    'vipSupport'?: boolean;
    'chatTransfer'?: ChatTransfer;
    'bookingId': string;
    /**
     * Type of user request similar to what's provided in chat
     * @type {string}
     * @memberof EncodeBookingRequest
     */
    'requestType'?: string;
    /**
     * User locale, used to direct requests to the appropriate agents
     * @type {string}
     * @memberof EncodeBookingRequest
     */
    'locale'?: string;
    /**
     * Kustomer funnel type for routing requests. String should be snake case
     * @type {string}
     * @memberof EncodeBookingRequest
     */
    'funnelType'?: string;
    'product': Product;
}


/**
 * @type EncodeBookingResponse
 * Response to encode a booking id
 * @export
 */
export type EncodeBookingResponse = { EncodeBookingResponse: 'Failure' } & EncodeFailure | { EncodeBookingResponse: 'Success' } & EncodeSuccess;

export const EncodeBookingResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type EncodeBookingResponseEnum = typeof EncodeBookingResponseEnum[keyof typeof EncodeBookingResponseEnum];


export interface EncodeFailure {
    'errors': Array<string>;
    'EncodeBookingResponse': EncodeBookingResponseEnum;
}


export interface EncodeGenericConversationFailure {
    'errors': Array<string>;
    'EncodeGenericConversationResponse': EncodeGenericConversationResponseEnum;
}


/**
 * Request to encode a generic conversation

 * `funnelType` - Kustomer funnel type for routing requests. String should be snake case
 * `requestType` - Type of user request similar to what's provided in chat
 * `locale` - User locale, used to direct requests to the appropriate agents
 * `chatTransfer` - The Chat Transfer object if needed
 * @export
 * @interface EncodeGenericConversationRequest
 */
export interface EncodeGenericConversationRequest {
    /**
     * Kustomer funnel type for routing requests. String should be snake case
     * @type {string}
     * @memberof EncodeGenericConversationRequest
     */
    'funnelType'?: string;
    /**
     * Type of user request similar to what's provided in chat
     * @type {string}
     * @memberof EncodeGenericConversationRequest
     */
    'requestType'?: string;
    /**
     * User locale, used to direct requests to the appropriate agents
     * @type {string}
     * @memberof EncodeGenericConversationRequest
     */
    'locale'?: string;
    'chatTransfer'?: ChatTransfer;
}
/**
 * @type EncodeGenericConversationResponse
 * Response to encode generic conversation
 * @export
 */
export type EncodeGenericConversationResponse = { EncodeGenericConversationResponse: 'Failure' } & EncodeGenericConversationFailure | { EncodeGenericConversationResponse: 'Success' } & EncodeGenericConversationSuccess;

export const EncodeGenericConversationResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type EncodeGenericConversationResponseEnum = typeof EncodeGenericConversationResponseEnum[keyof typeof EncodeGenericConversationResponseEnum];


export interface EncodeGenericConversationSuccess {
    'encodedCode': string;
    'EncodeGenericConversationResponse': EncodeGenericConversationResponseEnum;
}


export interface EncodeSuccess {
    'encodedCode': string;
    'EncodeBookingResponse': EncodeBookingResponseEnum;
}


/**
 * Exhaustive list of all products that the ivr support
 * @export
 * @enum {string}
 */

export const Product = {
    Flight: 'Flight',
    Ground: 'Ground',
    Home: 'Home',
    Lodging: 'Lodging'
} as const;

export type Product = typeof Product[keyof typeof Product];



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Encode generic conversation to 6 digit code
         * @param {EncodeGenericConversationRequest} encodeGenericConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0IvrEncodeGenericPost: async (encodeGenericConversationRequest: EncodeGenericConversationRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encodeGenericConversationRequest' is not null or undefined
            assertParamExists('apiV0IvrEncodeGenericPost', 'encodeGenericConversationRequest', encodeGenericConversationRequest)
            const localVarPath = `/api/v0/ivr/encode/generic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encodeGenericConversationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Encode Booking Id to 6 digit code
         * @param {EncodeBookingRequest} encodeBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0IvrEncodePost: async (encodeBookingRequest: EncodeBookingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encodeBookingRequest' is not null or undefined
            assertParamExists('apiV0IvrEncodePost', 'encodeBookingRequest', encodeBookingRequest)
            const localVarPath = `/api/v0/ivr/encode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(encodeBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Encode generic conversation to 6 digit code
         * @param {EncodeGenericConversationRequest} encodeGenericConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0IvrEncodeGenericPost(encodeGenericConversationRequest: EncodeGenericConversationRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EncodeGenericConversationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0IvrEncodeGenericPost(encodeGenericConversationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Encode Booking Id to 6 digit code
         * @param {EncodeBookingRequest} encodeBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0IvrEncodePost(encodeBookingRequest: EncodeBookingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EncodeBookingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0IvrEncodePost(encodeBookingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Encode generic conversation to 6 digit code
         * @param {EncodeGenericConversationRequest} encodeGenericConversationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0IvrEncodeGenericPost(encodeGenericConversationRequest: EncodeGenericConversationRequest, options?: any): AxiosPromise<EncodeGenericConversationResponse> {
            return localVarFp.apiV0IvrEncodeGenericPost(encodeGenericConversationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Encode Booking Id to 6 digit code
         * @param {EncodeBookingRequest} encodeBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0IvrEncodePost(encodeBookingRequest: EncodeBookingRequest, options?: any): AxiosPromise<EncodeBookingResponse> {
            return localVarFp.apiV0IvrEncodePost(encodeBookingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Encode generic conversation to 6 digit code
     * @param {EncodeGenericConversationRequest} encodeGenericConversationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0IvrEncodeGenericPost(encodeGenericConversationRequest: EncodeGenericConversationRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0IvrEncodeGenericPost(encodeGenericConversationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Encode Booking Id to 6 digit code
     * @param {EncodeBookingRequest} encodeBookingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0IvrEncodePost(encodeBookingRequest: EncodeBookingRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0IvrEncodePost(encodeBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



